<template>
  <div class="custom">
    <div class="custom-tool">
      <div class="ct-head">
        <img src="@/assets/img/custom/phone-head.png" />
      </div>
      <div class="ct-box">
        <div class="ctb-item" v-for="(component, index) in selectArr" :key="'components-' + index">
          <component :is="component.componentName" :ref="component.componentName + index" :info="component" :type="type" :index="index" @closeModel="closeModel(index, $event)" @close="delComponent(index)" @add="addComponentsByPosition" v-model="component.config"></component>
        </div>
        <div class="u-empty" v-if="false">暂无组件</div>
      </div>
      <div class="ct-components">
        <div class="ctc-title">新增组件</div>
        <div class="ctc-group" v-if="type === 1">
          <div class="ctc-item" v-for="(item, index) in commmonArr" :key="'commmon-' + index" @click="addComponents(item)">
            <i class="icon iconfont" :class="item.icon"></i>
            <div class="ctc-item-txt">{{item.title}}</div>
          </div>
        </div>
        <div class="ctc-group" v-if="type === 2">
          <div class="ctc-item" v-for="(item, index) in commmonArr2" :key="'commmon-' + index" @click="addComponents(item)">
            <i class="icon iconfont" :class="item.icon"></i>
            <div class="ctc-item-txt">{{item.title}}</div>
          </div>
        </div>
        <div class="ctc-group group-3" v-if="type === 3">
          <div class="ctc-item" v-for="(item, index) in commmonArr3" :key="'commmon-' + index" @click="addComponents(item)">
            <i class="icon iconfont" :class="item.icon"></i>
            <div class="ctc-item-txt">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import customText from "@components/custom-component/common/custom-text/custom-text.vue";
import customPicture from "@components/custom-component/common/custom-picture/custom-picture.vue";
import customVideo from "@components/custom-component/common/custom-video/custom-video.vue";
import customTitle from "@components/custom-component/common/custom-title/custom-title.vue";
import customSearch from "@components/custom-component/common/custom-search/custom-search.vue";
import customLink from "@components/custom-component/common/custom-link/custom-link.vue";
import customProduct from "@components/custom-component/common/custom-product/custom-product.vue";
export default {
  name: "custom-component",
  model: {
    prop: "Modal",
    event: "sendModal",
  },
  props: {
    Modal: {
      type: Array,
      default: [],
    },
    defaultArr: {
      type: Array,
      default: function () {
        return [
          {
            title: "产品分组",
            type: "product",
            icon: "",
            componentName: "customProduct",
            config: {
              type: 1,
              Name: "我的分组", // 分组名称
              ShowGroupName: 1, // 显示分组名称
              FirstPriority: 0, // 第一显示优先级
              SecondPriority: 0, // 第二显示优先级
              ListStyle: 0, // 列表样式
              ShowProductName: 1, // 显示产品的名称
              ShowProductPrice: 1, // 显示产品的价格
              Introduction: "", // 分组的描述
            },
          },
        ];
      },
    },
    type: {
      // 通用添加组件的列表   1：所有列表   2：筛选列表  3: 四个选项的筛选列表
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      commmonArr: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left", // 文本对齐格式
          },
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: "",
                },
              },
            ],
          },
        },
        {
          title: "标题",
          icon: "icon-biaoti",
          type: "title",
          componentName: "customTitle",
          config: {
            type: 1, // 标题类型 暂时只有 1
            content: "",
            position: "left", // 文本对齐格式
            padding: "12px", // 标题的边距
            fontSize: "12px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色
            link: {
              type: "3",
              value: "",
            },
          },
        },
        {
          title: "链接",
          icon: "icon-link",
          type: "link",
          componentName: "customLink",
          config: [
            {
              type: "", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
              name: "",
              url: "",
            },
          ],
        },
        {
          title: "产品搜索",
          icon: "icon-sousuo",
          type: "search",
          componentName: "customSearch",
          config: {
            type: 1, // 搜索类型 暂时只有 1
            words: [""],
            style: "circular", // 搜索外边框样式 （圆 \ 方）
            position: "left", // 文本对齐格式
            color: "#ccc",
            background: "#f5f5f5",
            borderColor: "#91c0ec",
          },
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0", // 视频封面累心 0 截取 1 自定义
          },
        },
      ],
      commmonArr2: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left", // 文本对齐格式
          },
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: "",
                },
              },
            ],
          },
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0", // 视频封面累心 0 截取 1 自定义
          },
        },
      ],
      commmonArr3: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left", // 文本对齐格式
          },
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: "",
                },
              },
            ],
          },
        },
        {
          title: "产品搜索",
          icon: "icon-sousuo",
          type: "search",
          componentName: "customSearch",
          config: {
            type: 1, // 搜索类型 暂时只有 1
            words: [""],
            style: "circular", // 搜索外边框样式 （圆 \ 方）
            position: "left", // 文本对齐格式
            color: "#ccc",
            // background: "#f5f5f5",
            background: "#fff",
            borderColor: "#eee",
          },
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0", // 视频封面累心 0 截取 1 自定义
          },
        },
      ],

      selectArr: [],
    };
  },
  computed: {
    ...mapGetters({
      destroy: "customComponentModule/getDestroy",
    }),
  },
  components: {
    customText,
    customPicture,
    customVideo,
    customTitle,
    customSearch,
    customLink,
    customProduct,
  },
  created() {
    if (this.defaultArr && this.defaultArr.length) {
      this.selectArr.push(...this.defaultArr);
    }
    if (this.Modal && this.Modal.length) {
      this.selectArr.push(...this.Modal);
    }
  },
  methods: {
    ...mapMutations({
      setDestroy: "customComponentModule/setDestroy",
      setSave: "customComponentModule/setSave",
    }),
    addDefaultComponents(item) {
      this.selectArr.push(JSON.parse(JSON.stringify(item)));
    },
    addComponents(item) {
      this.selectArr.push(JSON.parse(JSON.stringify(item)));
    },
    addComponentsByPosition(item, index) {
      this.selectArr.splice(index, 0, JSON.parse(JSON.stringify(item)));
    },
    delComponent(i) {
      let modal = this.selectArr.filter((c, idx) => {
        return idx !== i;
      });
      this.selectArr = modal;
      this.$emit("sendModal", modal);
    },
    closeModel(i, e) {
      console.log(this.$refs);
      this.selectArr.forEach((c, idx) => {
        let name = c.componentName + i;
        if (idx !== i) {
          if (this.$refs[name]) {
            this.$refs[name][0].hide(false);
          }
        }
      });
    },
    async saveCustom() {
      this.setSave(true); // 点击保存 子组件监听这个参数 传递改变的Modal数据
      setTimeout(() => {
        let customData = [];
        this.selectArr.forEach((e) => {
          customData.push({
            [e.type]: e.config,
          });
        });
        this.$emit("sendModal", customData);
        this.setSave(false);
      }, 400);
    },
  },
  destroyed() {
    this.setDestroy(true);
    this.setSave(false);
  },
};
</script>

<style scoped lang="scss">
.custom {
  width: 968px;
  margin: 40px auto; 
  &-tool {
    width: 375px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    position: relative;
    padding-top: 64px;
    transition: all 1.2s;
    &:hover {
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    }
    .ct {
      &-head {
        position: absolute;
        top: 0;
        left: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &-box {
        min-height: 320px;
        background: #f5f5f5;
        padding-bottom: 10px;
      }
      &-components {
        .ctc {
          &-title {
            padding: 10px 20px;
            font-size: 14px;
            color: #333;
          }
          &-group {
            padding: 0 20px 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
          }
          &-item {
            width: 95px;
            height: 60px;
            margin-bottom: 10px;
            background-color: #ebebeb;
            text-align: center;
            padding-top: 5px;
            cursor: pointer;
            .iconfont {
              font-size: 20px;
              color: #222;
            }
            &-txt {
              width: 100%;
              font-size: 12px;
              color: #222; 
              line-height: 1;
            }
          }
        }
        .group-3 {
          .ctc-item {
            width: 75px;
          }
        }
      }
    }
  }
}
</style>
